import React from "react";
import PropTypes from "prop-types";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

const CategoryCard = (props) => {
  return (
    <Card raised id={props.idCategory} sx={{ mb: 4, minWidth: 300 }}>
      <CardContent>
        <Typography>
          <strong>Nome:</strong> {props.name}
        </Typography>
      </CardContent>
    </Card>
  );
};

CategoryCard.defaultProps = {
  list: false,
  idCategory: undefined,
  name: undefined,
};

CategoryCard.propTypes = {
  list: PropTypes.bool,
  idCategory: PropTypes.string,
  name: PropTypes.string,
};

export default CategoryCard;
